import React from 'react';
import Skeleton from 'src/components/Skeleton/Skeleton';
import RoomAccordionSkeleton from 'src/components/AssetsTable/skeletons/RoomAccordionSkeleton';

const SuiteAssetsSkeleton = () => (
  <>
    <div className="area-assets-header">
      <div className="area-assets-search">
        <Skeleton variant="rect" width="100%" height="2.25rem" />
      </div>
      <div className="area-assets-header-actions">
        <span style={{ marginRight: '1.25rem', marginLeft: '1rem' }}>
          <Skeleton variant="rect" width="7rem" height="2.25rem" />
        </span>
        <Skeleton variant="rect" width="7rem" height="2.25rem" />
      </div>
    </div>
    <RoomAccordionSkeleton />
  </>
);

export default SuiteAssetsSkeleton;
